











































import { defineComponent, PropType } from '@vue/composition-api';
import type { RunCourseRow, ReportRouteSlim, RoutePosition, ContextMenuMode } from '@/models/runCourse';
import RouteRow from './RouteRow.vue';

export default defineComponent({
  components: {
    RouteRow,
  },
  props: {
    rows: {
      type: Array as PropType<RunCourseRow[]>,
      required: true,
    },
    sheetIdx: {
      type: Number,
      required: true,
    },
    hasLastDriveResult: {
      type: Boolean,
      default: false,
    },
    timeSpanSumDisplay: {
      type: String,
      default: '',
    },
    distanceSumDisplay: {
      type: String,
      default: '',
    },
  },
  emits: ['create', 'edit', 'show-contextmenu', 'update-bikou'],
  setup(props, { emit }) {
    const onCreate = (params: RoutePosition) => {
      emit('create', params);
    };

    const onEdit = (route: ReportRouteSlim, params: RoutePosition) => {
      emit('edit', route, params);
    };

    const onShowContextmenu = (event: MouseEvent, params: RoutePosition, mode: ContextMenuMode) => {
      emit('show-contextmenu', event, params, mode);
    };

    const onUpdateBikou = (sheetIdx: number, rowIdx: number, value: string) => {
      emit('update-bikou', sheetIdx, rowIdx, value);
    };

    return {
      onCreate,
      onEdit,
      onShowContextmenu,
      onUpdateBikou,
    };
  },
});
